import api from './axios';
import { MatchCounts, MatchCountsRequest } from '../types';

export const fetchMatchCounts = (request: MatchCountsRequest): Promise<MatchCounts> =>
  api.post<MatchCounts>('/api/matches/counts', request).then(res => res.data);
